import { FC, useState } from 'react';

import classNames from 'classnames';

import { Heading, Pressable } from '../../../shared/ui';

import { IMacCardInfo } from '../../../store/mac.slice';

import { MacCard } from './MacCard';
import { MacCardViewer } from './mac-card-viewer';

const pluralizeCards = (n: number) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} карта`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} карты`;

  return `${n} карт`;
};

export interface IMacResultsMobileProps {
  cards: IMacCardInfo[];
  /** Заголовок: у психолога «Выбор клиента», у клиента «Ваш выбор» */
  title?: string;
}

/** Мобильный 1:1: карты, выбранные клиентом. По центру экрана, крупно; тап открывает полноэкранный просмотр. */
export const MacResultsMobile: FC<IMacResultsMobileProps> = ({ cards, title = 'Выбор клиента' }) => {
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);
  const count = cards.length;
  // 1 карта — одна колонка ограниченной ширины; 2–4 — сетка 2 колонки (третья карта по центру второй строки)
  const gridClass = count === 1 ? 'mx-auto max-w-[240px] grid-cols-1' : 'grid-cols-2';

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0 px-4 pb-2 pt-1">
        <div className="flex items-baseline justify-between gap-3">
          <Heading as="h3" size="md" tone="inverse">
            {title}
          </Heading>
          <span className="text-ui text-white/70">{pluralizeCards(count)}</span>
        </div>
        <p className="text-ui-xs text-white/60">Нажмите на карту, чтобы рассмотреть</p>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-3">
        <div className="flex min-h-full">
          <div className={classNames('m-auto grid w-full max-w-[420px] gap-3', gridClass)}>
            {cards.map((card, i) => (
              <Pressable
                key={card.id}
                onClick={() => setViewerIndex(i)}
                aria-label={`Карта ${i + 1}: открыть`}
                className={classNames(
                  'relative aspect-[110/140] w-full overflow-hidden rounded-card border-2 border-accent shadow-overlay',
                  { 'col-span-2 mx-auto !w-[calc(50%-6px)]': count === 3 && i === 2 },
                )}
              >
                <MacCard id={card.id} img={card.img} zoomable={false} fill />
                <span className="absolute left-2 top-2 z-[11] flex h-6 w-6 items-center justify-center rounded-full bg-black/50 text-ui-xs font-medium text-white">
                  {i + 1}
                </span>
              </Pressable>
            ))}
          </div>
        </div>
      </div>

      {viewerIndex !== null && (
        <MacCardViewer cards={cards} initialIndex={viewerIndex} onClose={() => setViewerIndex(null)} />
      )}
    </div>
  );
};
